import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const faqs = [
  {
    q: "What exactly is VelTech Ghana?",
    a: "VelTech Ghana is a complete cloud-based school management system. It handles everything — student records, attendance, exams, report cards, fees, payroll, library, transport, hostel, online admissions, school website, and 50+ reports. All accessible from any device with internet.",
  },
  {
    q: "Is this cloud-based? Do we need to install anything?",
    a: "100% cloud-based. No installation, no server room, no IT team needed. You access everything through your web browser. We handle all the hosting, backups, updates, and security for you.",
  },
  {
    q: "How do we get started?",
    a: "Simple. Request a custom proposal through our contact form or WhatsApp. We visit your school, assess your needs, and deliver a tailored proposal with pricing built specifically for your school. No two schools pay the same — we customize everything.",
  },
  {
    q: "Do you provide on-site training?",
    a: "Yes. We physically come to your school to set up the system, migrate your existing data, and train your entire staff hands-on. No Zoom calls. No guesswork. We're right there with you until everyone is comfortable.",
  },
  {
    q: "Can parents access the system?",
    a: "Yes. Parents get their own portal to view their child's attendance, grades, fee statements, exam results, and communicate with teachers — all from their mobile phones.",
  },
  {
    q: "Does it support the Ghanaian curriculum and GES standards?",
    a: "Absolutely. Our grading systems, report card formats, mark sheets, terminal reports, and academic structures are fully aligned with Ghana Education Service (GES) standards for both JHS and SHS.",
  },
  {
    q: "How does fee collection work?",
    a: "The system generates invoices automatically, sends reminders to parents, and tracks all payments in real-time. You can see exactly who has paid, who hasn't, and manage all expenses and income from one place.",
  },
  {
    q: "Can we manage payroll and HR through the system?",
    a: "Yes. Full payroll management with salary templates, hourly templates, overtime tracking, leave applications, and payment processing. Your HR and accounts team will love it.",
  },
  {
    q: "What happens to our data? Is it secure?",
    a: "Your data is protected with bank-grade encryption and daily automatic backups. We use role-based permissions so each user only sees what they need to. We're fully compliant with Ghana's Data Protection Act.",
  },
  {
    q: "What if we already have student data in spreadsheets or exercise books?",
    a: "No problem. During our on-site setup, we import all your existing data — whether it's in Excel, paper records, or another system. We ensure zero data loss during migration.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="relative bg-gray-50 py-24 lg:py-32 overflow-hidden">
      <div className="blob-violet" style={{ top: '10%', left: '-10%' }} />

      <div className="relative z-10 max-w-3xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight text-[#0A0A0A] mb-4"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
            data-testid="faq-heading"
          >
            Frequently Asked Questions
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-2">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b-2 border-gray-200 last:border-b-0"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left text-base text-[#0A0A0A] hover:text-gray-600 hover:no-underline py-5 font-black"
                style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
              >
                {faq.q}
              </AccordionTrigger>
              <AccordionContent
                className="text-gray-500 text-sm leading-relaxed pb-5 font-medium"
                style={{ fontFamily: "'Satoshi', sans-serif" }}
              >
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
